/**
 * Notification types.
 * @type {{COMMUNICATION: string}}
 */
export const NOTIFICATION_TYPES = {
    COMMUNICATION: 'communication',
    MHR_HANDBOOKS: 'mhrHandbook',
    INSIGHTS: 'Insights',
};
